/* eslint-disable max-len */
// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.home = (await import('./pages/Home')).Home;
    Components.microApp = (await import('./pages/microApp/MicroApp')).MicroApp;
    Components.pip = (await import('./pages/pip/Pip')).Pip;
    Components.pipEstimate = (await import('./pages/pip/PipEstimate')).PipEstimate;
    Components.pipMandi = (await import('./pages/pip/PipMandi')).PipMandi;
    Components.pcp = (await import('./pages/pcp/Pcp')).Pcp;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  home: {
    name: 'Home',
    componentName: 'Home',
    chunk: () => import('./pages/Home'),
    get component() {
      return ssr
        ? serverPages.home
        : currentRouteName === 'Home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/',
    channel: null
  },
  microApp: {
    name: 'MicroApp',
    componentName: 'MicroApp',
    chunk: () => import('./pages/microApp/MicroApp'),
    get component() {
      return ssr
        ? serverPages.microApp
        : currentRouteName === 'MicroApp'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.MicroApp })));
    },
    path: '/:context?/:any?',
    channel: null
  },
  pip: {
    name: 'Pip',
    componentName: 'Pip',
    chunk: () => import('./pages/pip/Pip'),
    get component() {
      return ssr
        ? serverPages.pip
        : currentRouteName === 'Pip'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Pip })));
    },
    path: '/:context?/p/:slug?/:itemId',
    channel: null
  },
  pipEstimate: {
    name: 'PipEstimate',
    componentName: 'PipEstimate',
    chunk: () => import('./pages/pip/PipEstimate'),
    get component() {
      return ssr
        ? serverPages.pipEstimate
        : currentRouteName === 'PipEstimate'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PipEstimate })));
    },
    path: '/:context?/e/:slug?/:itemId',
    channel: null
  },
  pipMandi: {
    name: 'PipMandi',
    componentName: 'PipMandi',
    chunk: () => import('./pages/pip/PipMandi'),
    get component() {
      return ssr
        ? serverPages.pipMandi
        : currentRouteName === 'PipMandi'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PipMandi })));
    },
    path: '/:context?/p/mandi/:slug?/:itemId',
    channel: null
  },
  pcp: {
    name: 'Pcp',
    componentName: 'Pcp',
    chunk: () => import('./pages/pcp/Pcp'),
    get component() {
      return ssr
        ? serverPages.pcp
        : currentRouteName === 'Pcp'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Pcp })));
    },
    path: [
      ':context?/custom-blinds/Configurator',
      ':context?/custom-blinds/configurator/EditByGuid',
      ':context?/custom-blinds/configurator/CreateMandi',
      ':context?/custom-blinds/configurator/CreateEstimate',
      ':context?/custom-blinds/configurator/EditMandi',
      ':context?/custom-blinds/configurator/EditEstimate',
      ':context?/custom-blinds/configurator/Copy',
      ':context?/custom-blinds/configurator/Draft',
    ],
    channel: null
  }
});
